module.exports = __webpack_public_path__ + "static/media/terms006.224c890f.png";